__turbopack_context__.v({
  "ArrowBg": "order2-module__-ouYFa__ArrowBg",
  "CustomeInput": "order2-module__-ouYFa__CustomeInput",
  "OrderConfirmFrom": "order2-module__-ouYFa__OrderConfirmFrom",
  "OrderConfirmLeft": "order2-module__-ouYFa__OrderConfirmLeft",
  "OrderConfirmLeft3": "order2-module__-ouYFa__OrderConfirmLeft3",
  "OrderConfirmRight": "order2-module__-ouYFa__OrderConfirmRight",
  "Payment": "order2-module__-ouYFa__Payment",
  "Payment3": "order2-module__-ouYFa__Payment3",
  "VarientMainDiv": "order2-module__-ouYFa__VarientMainDiv",
  "VarientMainDiv3": "order2-module__-ouYFa__VarientMainDiv3",
  "checkbox": "order2-module__-ouYFa__checkbox",
  "checkmark": "order2-module__-ouYFa__checkmark",
  "containerVarient": "order2-module__-ouYFa__containerVarient",
  "containerVarientLeft": "order2-module__-ouYFa__containerVarientLeft",
  "containerVarientLeftImg": "order2-module__-ouYFa__containerVarientLeftImg",
  "containerVarientRight": "order2-module__-ouYFa__containerVarientRight",
  "containerVarientRight__dflex": "order2-module__-ouYFa__containerVarientRight__dflex",
  "containerVarientRight__dflex_button": "order2-module__-ouYFa__containerVarientRight__dflex_button",
  "containerVarient_Flex": "order2-module__-ouYFa__containerVarient_Flex",
  "d_flex": "order2-module__-ouYFa__d_flex",
  "img": "order2-module__-ouYFa__img",
  "left": "order2-module__-ouYFa__left",
  "minus": "order2-module__-ouYFa__minus",
  "orderDesign": "order2-module__-ouYFa__orderDesign",
  "plus": "order2-module__-ouYFa__plus",
  "right": "order2-module__-ouYFa__right",
});
